import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const fetchEvent = ({
  cancelToken,
  eventId,
  routes = { event_path: Routes.event_path },
}) =>
  axios
    .get(routes.event_path(eventId, { format: 'json' }), {
      cancelToken: cancelToken?.token,
    })
    .then(({ data: { event } }) => event)
    .catch((error) => {
      if (error.message === CANCEL_FETCH_MESSAGE) {
        return;
      }
      displayXhrError(error);
    });

export default fetchEvent;
